import React from "react";
import HeroSectionPage from "./HeroSectionPage";
import { EmiTopupSection } from "./EmiTopupSection";
import { AskedQuestions } from "./AskedQuestions";
import LoanConsolidate from "./LoanConsolidate";
import WhyChooseMinemi from "./WhyChooseMinemi";
import { Helmet } from "react-helmet-async";
// import NewFaq from "./NewFaq";
// import LoanTopUpCalculator from "./LoanTopUpCalculator";
// import EmiCalculate from "./EmiCalculate";

export default function ConsolidateEmiSection() {
  return (
    <>
      <Helmet>
        <title>Consolidate EMI - Minemi</title>
      </Helmet>
      <HeroSectionPage />
      <EmiTopupSection />
      {/* <EmiCalculate /> */}
      <LoanConsolidate />
      <AskedQuestions />
      <WhyChooseMinemi />
      {/* <LoanTopUpCalculator /> */}
      {/* <NewFaq /> */}
    </>
  );
}
